import { guidFor } from '@ember/object/internals';
import { uploadResultToNodeAttrs } from '../config/specs/decorators/uploadable';
import { NodeSelection } from 'prosemirror-state';
export function updateNodeWithUploadResult(editorView, uploadResult, guid) {
  guid = guid || guidFor(uploadResult.file);
  let pos = findNodeByFileGUID(editorView, guid);
  if (pos.fileNode) {
    let attrs = Object.assign({}, pos.fileNode.attrs, uploadResultToNodeAttrs(uploadResult), srcAttr(uploadResult));
    applyNewAttrsToFileNode(editorView, pos, attrs);
  }
}
export function findNodeByFileGUID(editorView, fileGUID) {
  let from = 0;
  let to = 0;
  let fileNode;
  editorView.state.doc.descendants((node, pos, _) => {
    if (node.attrs.fileGUID === fileGUID) {
      from = pos;
      to = from + node.nodeSize;
      fileNode = node;
      return false;
    }
    return true;
  });
  return {
    fileNode,
    from,
    to
  };
}
export function applyNewAttrsToFileNode(editorView, pos, attrs) {
  if (pos.fileNode) {
    let node = pos.fileNode.type.createAndFill(attrs);
    if (node) {
      let tr = editorView.state.tr;
      tr.delete(pos.from, pos.to);
      tr.insert(pos.from, node);
      if (editorView.state.selection instanceof NodeSelection && pos.fileNode === editorView.state.selection.node) {
        tr.setSelection(NodeSelection.create(tr.doc, pos.from));
      }
      editorView.dispatch(tr);
    }
  }
}
function srcAttr(uploadResult) {
  if (uploadResult.type === 'success') {
    let {
      uploadUrl
    } = uploadResult;
    return {
      src: uploadUrl
    };
  }
  return {};
}